import { NotFoundPage } from '../src';

export default function NotFound() {
  return <NotFoundPage />;
}
